import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	timeCentric: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.sla-display-format.time-centric',
		defaultMessage: 'Time centric e.g.',
		description: 'label for the old sla display format',
	},
	dueDateCentric: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.sla-display-format.due-date-centric',
		defaultMessage: 'Due date centric e.g.',
		description: 'label for the new sla display format',
	},
});
